import { render, staticRenderFns } from "./BackerCenterPledgeCard.vue?vue&type=template&id=1d48edf2"
import script from "./BackerCenterPledgeCard.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports